module.exports = __webpack_public_path__ + "img/digital_2.a75df39d.jpg";